import { apiFetch } from './api';

/**
 * Espace pédagogique : les supports de formation rangés en dossiers et
 * sous-dossiers. L'équipe les gère ; un formateur ne fait que les lire.
 */

const API_URL = process.env.REACT_APP_API_URL || '/api';

/** Tout l'espace d'un coup : { dossiers, fichiers }. */
export function getEspacePedagogique() {
  return apiFetch('/pedagogie');
}

export function creerDossierPedagogique({ nom, parentId = null }) {
  return apiFetch('/pedagogie/dossiers', { method: 'POST', body: JSON.stringify({ nom, parentId }) });
}

/** Renomme et/ou déplace (`parentId: null` = à la racine). */
export function modifierDossierPedagogique(id, corps) {
  return apiFetch(`/pedagogie/dossiers/${id}`, { method: 'PATCH', body: JSON.stringify(corps) });
}

export function supprimerDossierPedagogique(id) {
  return apiFetch(`/pedagogie/dossiers/${id}`, { method: 'DELETE' });
}

/** Dépose plusieurs fichiers d'un coup (multipart, hors apiFetch qui force le JSON). */
export async function deposerSupports(fichiers, { dossierId = null } = {}) {
  const donnees = new FormData();
  for (const f of fichiers) donnees.append('fichiers', f, f.name);
  if (dossierId) donnees.append('dossierId', String(dossierId));
  const res = await fetch(`${API_URL}/pedagogie/fichiers`, {
    method: 'POST',
    body: donnees,
    credentials: 'include',
  });
  const corps = await res.json().catch(() => ({}));
  if (!res.ok) {
    const err = new Error(corps?.message || `Dépôt impossible (${res.status})`);
    err.status = res.status;
    throw err;
  }
  return corps;
}

/** Renomme le fichier affiché et/ou le déplace (`dossierId: null` = à la racine). */
export function modifierSupport(id, corps) {
  return apiFetch(`/pedagogie/fichiers/${id}`, { method: 'PATCH', body: JSON.stringify(corps) });
}

export function supprimerSupport(id) {
  return apiFetch(`/pedagogie/fichiers/${id}`, { method: 'DELETE' });
}

export function urlSupport(id, { apercu = false } = {}) {
  return `${API_URL}/pedagogie/fichiers/${id}/fichier${apercu ? '?apercu=1' : ''}`;
}
